<div class="post-container">    
    <div class="navigation-content">
        <h4 routerLink="/categories"><< powrót do kategorii</h4>
    </div>
    <div class="post-content">
        <div class="loader" *ngIf="!post">
            <h2>Czekaj...</h2>
        </div>
        <div *ngIf="post" class="post-game">
            
            <app-task-word *ngIf="post.game_type === 'words'"
                [post]="post">
            </app-task-word>
            
            <app-task-memory *ngIf="post.game_type === 'memory'"
                [post]="post">
            </app-task-memory>
            
            <app-task-puzzle *ngIf="post.game_type === 'puzzle'"            
                [post]="post">
            </app-task-puzzle>
            
            <div class="post-navigation">
                <button *ngIf="post.previous" 
                    class="dark"
                    [routerLink]="['/task', post.previous]">
                    Wróć
                </button>
                <button *ngIf="post.next" 
                    class="dark"
                    [routerLink]="['/task', post.next]">
                    <ng-container *ngIf="post.game_type === 'memory'">Znajdź kolejne pary!</ng-container>
                    <ng-container *ngIf="post.game_type !== 'memory'">Poznaj kolejne słówko!</ng-container>                    
                </button>
            </div>
        </div>
    </div>
</div>
